/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { Box, SystemProps } from "flicket-ui";
import {
  EventQuery,
  VenueAddressFragment,
  VenueInfoFragment,
} from "~graphql/sdk";
import { DesktopSubHeader } from "~components/common/common.BaseSubHeader";
import { useOrganization } from "~hooks";
import { getEventVenueLocation } from "~lib/helpers/getEventVenueLocation";
import { formatEventDateRange } from "~lib/helpers/formatDate";

type DesktopDetailProps = EventQuery["event"] & {
  showSeatsCTA: boolean;
  isSinglePage: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

type EventTitleProps = Pick<
  DesktopDetailProps,
  "isSinglePage" | "title" | "startDate" | "endDate"
> & {
  hideBackLink?: boolean;
  backToLinkText?: string;
  backToLink?: string;
  tourId?: string;
  colour?: SystemProps["color"];
  venue: VenueInfoFragment & VenueAddressFragment;
};

export const EventTitle = ({
  isSinglePage,
  backToLinkText = "Back to Events",
  backToLink = "/",
  hideBackLink = false,
  title,
  startDate,
  endDate,
  venue,
  tourId,
  colour = "white",
}: EventTitleProps) => {
  const { hasFeature } = useOrganization();

  const venueName = getEventVenueLocation(venue);

  const subTitle = (
    <>
      {formatEventDateRange(startDate, endDate, {
        format: "basicLong",
        showStartTime: !hasFeature("hideEventTime"),
        timeZone: venue?.timezone,
        locale: venue?.locale,
      })}
      &nbsp;
      {!!venueName && (
        <Box as="span" d={{ _: "none", md: "inline-block" }}>
          - {venueName}
        </Box>
      )}
    </>
  );
  return (
    <DesktopSubHeader
      title={title}
      subTitle={subTitle}
      isSinglePage={isSinglePage}
      backToLinkText={backToLinkText}
      backToLink={tourId ? `/tours/${tourId}` : backToLink}
      hideBackLink={hideBackLink}
      colour={colour}
    />
  );
};
